import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, Space } from 'antd';
import { useAuth } from '../../context/AuthContext';
import './FolderCreateModal.css';

const { Option } = Select;

function FolderEditModal({
	visible,
	onClose,
	onSubmit,
	folders,
	tags,
	currentFolder,
	loading = false,
}) {
	const [form] = Form.useForm();
	const { orgData } = useAuth();

	useEffect(() => {
		if (currentFolder) {
			form.setFieldsValue({
				name: currentFolder.name,
				visibility: currentFolder.visibility,
				tagId: currentFolder.tagId,
				parentFolderId: currentFolder.parentFolderId || 'root',
			});
		}
	}, [currentFolder, form]);

	const handleSubmit = async (values) => {
		try {
			await onSubmit(currentFolder.id, values);
			form.resetFields();
		} catch (error) {
			console.error('Submit error:', error);
		}
	};

	return (
		<Modal
			title='Edit Folder'
			open={visible}
			onCancel={() => {
				form.resetFields();
				onClose();
			}}
			okText='Save'
			confirmLoading={loading}
			onOk={() => form.submit()}
			className='common-modal folder-modal'>
			<Form
				form={form}
				layout='vertical'
				onFinish={handleSubmit}>
				<Form.Item
					name='name'
					label='Name'
					rules={[
						{ required: true, message: 'Please enter a name' },
					]}>
					<Input placeholder='Enter name' />
				</Form.Item>

				<Form.Item
					name='parentFolderId'
					label='Parent Folder'>
					<Select placeholder='Select parent folder'>
						<Option value='root'>Root Folder</Option>
						{folders
							.filter((folder) => folder.id !== currentFolder?.id) // Prevent selecting itself
							.map((folder) => (
								<Option
									key={folder.id}
									value={folder.id}>
									{folder.name}
								</Option>
							))}
					</Select>
				</Form.Item>

				<Form.Item
					name='visibility'
					label='Visibility'
					rules={[
						{ required: true, message: 'Please select visibility' },
					]}>
					<Select placeholder='Select visibility'>
						<Option value='hidden'>Hidden</Option>
						<Option value='private'>Private</Option>
						<Option value='public'>Public</Option>
					</Select>
				</Form.Item>

				<Form.Item
					name='tagId'
					label='Tag'>
					<Select
						allowClear
						placeholder='Select tag'
						optionLabelProp='label'>
						{tags.map((tag) => (
							<Option
								key={tag.id}
								value={tag.id}
								label={tag.name}>
								<Space>
									<div
										style={{
											width: 16,
											height: 16,
											backgroundColor: tag.color,
											borderRadius: 4,
										}}
									/>
									{tag.name}
								</Space>
							</Option>
						))}
					</Select>
				</Form.Item>
			</Form>
		</Modal>
	);
}

export default FolderEditModal;
